import axios from "axios";

const configuration = {
  headers: {
    "Content-Type": "application/json",
    "x-platform": window.cordova
      ? window.cordova.platformId === "ios"
        ? "ios"
        : "android"
      : "web",
    "Cache-Control": "no-cache",
  },
};

const instance = axios.create(configuration);

export const headerSet = (token) => {
  delete instance.defaults.headers.common["Authorization"];
  instance.defaults.headers.common.Authorization = token;
};

const requestHandler = (request) => {
  console.log(request);
  return request;
};

instance.interceptors.request.use((request) => requestHandler(request));

const logApi = (method, url, body = "", response) => {
  // eslint-disable-next-line no-console
  /*console.log(
    `${method} URL : ${url}\nHEADERS: `,
    body,
    `\nRESPONSE: `,
    response.data
  );*/
};

const logAPIError = (method, url, body = "", err) => {
  if (process.env.REACT_APP_ENV !== "prod") {
    console.log(
      `ERROR - ${method} URL : ${url}\nHEADERS: `,
      body,
      `\nRESPONSE: `,
      err.message
    );
  }
};

const GET = async (_URL, options) => {
  const response = await instance.get(_URL, options).catch(function (err) {
    return err.response;
  });
  //logApi("GET", _URL, options, response);
  return response;
};

const POST = async (_URL, data = null, options, isShowLoader = false) => {
  let response;
  // if (isShowLoader) {
  //   store.dispatch(setLoaderVisibility(true));
  // }
  response = await instance.post(_URL, data, options).catch(function (err) {
    /*console.log(`errror code - ${JSON.stringify(err)}`);*/
    // if (isShowLoader) {
    //   store.dispatch(setLoaderVisibility(false));
    // }
    // if (err.response?.status === 401) {
    //   const logedIn = localStorage.getItem("userMobNumber");
    //   if (logedIn) {
    //     logout();
    //   }
    // }
    // /*console.log(`post request erro - ${JSON.stringify(err.response)}`);*/
    // logAPIError("POST", _URL, data, err);
    return err.response;
  });
  logApi("POST", _URL, data, response);
  // if (isShowLoader) {
  //   store.dispatch(setLoaderVisibility(false));
  // }
  return response;
};

export { GET, POST };
